import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from 'src/app/services/user.service';
import { userLst } from 'src/app/models/userLst';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinner} from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { CreateEditEmpleadoComponent } from '../create-edit-empleado/create-edit-empleado.component';
import { ModalQrComponent } from '../../varios/modal-qr/modal-qr.component';

@Component({
  selector: 'app-index-empleados',
  templateUrl: './index-empleados.component.html',
  styleUrls: ['./index-empleados.component.scss']
})
export class IndexEmpleadosComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  // pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  searchString: string = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public userSvc: UserService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: userLst[] = [];
    this.displayedColumns = ['nombre', 'email', 'documento', 'botones'];

    this.dataSource = new MatTableDataSource<userLst>(ELEMENT_DATA);
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.getUsers(0, 10);
  }

  ngOnInit(): void {}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getUsers(page: number, numReg: number) {
    this.isLoadingResults = true;
    this.userSvc
      .getEmpleados(page, numReg, this.searchString)
      .subscribe((result) => {
        this.dataSource = new MatTableDataSource<userLst>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;

        //this.displayedColumns = ['id', 'nombre', 'email', 'documento'];
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getUsers(event.pageIndex, event.pageSize);
  }

  onEnter() {
    console.log('boton enter');
    this.getUsers(0, 10);
  }

  openDialogCreateUser(): void {
    let dialogRef = this.dialog.open(CreateEditEmpleadoComponent, {
      data: null,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result=='false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por creacion');
        this.getUsers(this.pageIndex, this.pageSize);
      }
    }); 
  }

  descargarQr(obj: any) {
    console.log(obj);
    let dialogRef = this.dialog.open(ModalQrComponent, {
      data: {qr:obj.qr, nombre:obj.nombre},
      panelClass: 'modal-qr-panel',
    });
  }

  edit(obj: any) {
    console.log(obj);

    let dialogRef = this.dialog.open(CreateEditEmpleadoComponent, {
      data: obj,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result=='false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por edicion');
        this.getUsers(this.pageIndex, this.pageSize);
      }
    }); 
  }

  delete(obj: any) {
    console.log(obj);
    this.alertify.confirm('Confirma que quiere eliminar el usuario?', () => {
      this.userSvc.EliminarUsuario(obj).subscribe((res) => {
        if (res) {
          this.getUsers(this.pageIndex, this.pageSize);
          this.alertify.success('Usuario eliminado correctamente.');
        } else {
          this.alertify.error('El usuario no se ha podido eliminar.');
        }
      });
    });
  }

}
